import axios from '@axios'

export default {
  findByTipoFaixaAndPeriodo(tipoFaixaId, periodoId) {
    return axios.get('/financeiro/valor_faixas/buscar', { params: { tipoFaixaId, periodoVigenciaId: periodoId } })
  },
  save(data) {
    return axios.post('/financeiro/valor_faixas', data)
  },
  gerarMensalidadesLote(tipoFaixaId, periodoId) {
    return axios.post(`/financeiro/comandos/gerar-mensalidades-lote?tipoFaixaId=${tipoFaixaId}&periodoId=${periodoId}`)
  },
  gerarMensalidadesLoteTodos(periodoId) {
    return axios.post(`/financeiro/comandos/gerar-mensalidades-lote-todos?periodoId=${periodoId}`)
  },
  findLogById(id) {
    return axios.get(`/financeiro/comandos/logs-geracao/${id}`)
  },
  findAllLogs() {
    return axios.get('/financeiro/comandos/logs-geracao')
  },
  corrigirValoresLote(tipoFaixaId, periodoId) {
    return axios.post(`/financeiro/comandos/corrigir-valores-lote?tipoFaixaId=${tipoFaixaId}&periodoId=${periodoId}`)
  },
  findLogItemsPaged(logId, params) {
    return axios.get(`/financeiro/comandos/logs-geracao/${logId}/itens`, { params })
  },
}
